"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Config_1 = require("../../services/Config");
var ConfigProvider = /** @class */ (function (_super) {
    __extends(ConfigProvider, _super);
    function ConfigProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loaded: false,
            loading: false,
        };
        return _this;
    }
    ConfigProvider.prototype.componentDidMount = function () {
        var _this = this;
        // En mode production, on charge un fichier de configuration
        // Sinon on passe par les variables d'environnements et on n'a pas besoin
        // de charger de fichier de configuration
        if (process.env.NODE_ENV === 'production') {
            var url = this.props.url;
            fetch(url || '/config.json')
                .then(function (response) {
                return response.json();
            })
                .then(function (content) {
                Config_1.loadConfig(content);
                _this.setState({
                    loaded: true,
                });
                _this.props.onLoad && _this.props.onLoad();
            });
        }
        else {
            this.setState({
                loaded: true,
            });
            this.props.onLoad && this.props.onLoad();
        }
    };
    ConfigProvider.prototype.render = function () {
        if (this.state.loading) {
            return this.props.loading;
        }
        if (this.state.loaded) {
            return react_1.default.createElement(react_1.default.Fragment, null, this.props.children);
        }
        return null;
    };
    return ConfigProvider;
}(react_1.PureComponent));
exports.ConfigProvider = ConfigProvider;
//# sourceMappingURL=index.js.map